<template>
    <div v-if="topic" class="post-stats z1 no-select" :class="{ 'no-comments': !topic.permissions.includes('READ') }">
        <div class="card-inner post-statistics">
            <i class="fa fa-lock light-text mimic-title post-closed-icon" v-if="topic.closed">
                <span>
                    {{ translations['forum.topic_closed'] }}
                </span>
            </i>
            <div class="like post-likes-count light-text mimic-title" v-if="showLikesCount">
                <i class="far like-button-vue tw-mr-1"
                    :class="[{ 'font-blue': topic.liked_by_me }, { 'secondary-c-hover': user && !topic.closed && !user.impersonating }, likeIcon ? likeIcon : settings.like_icon]"
                    @click="likePost({ id: topic.post_id, bool: !topic.liked_by_me, model: topic.plural, object: topic, closed: topic.closed })">
                    <template v-if="topic.likes_count">
                        <p class="count" :class="{ 'secondary-c': topic.liked_by_me }">{{ topic.likes_count }}</p>
                    </template>
                    <template v-else>
                        <p class="count">0</p>
                    </template>
                </i>
                <div class="stats-text">
                    <template v-if="topic.status !== 'invisible'">
                        <!-- normal topic -->
                        <template v-if="topic.likes_count == '1'">
                            {{ translations['admin.you_like'] }}
                        </template>
                        <template v-else>
                            {{ translations['admin.like_multi'] }}
                        </template>
                    </template>
                    <template v-else>
                        <!-- intro topic -->
                        <template v-if="topic.likes_count === 1 && topic.user().id != user.id">
                            {{ translations['forum.other_welcomed_one'] }}
                        </template>
                        <template v-else-if="topic.likes_count != 1 && topic.user().id != user.id">
                            {{ translations['forum.other_welcomed_more'] }}
                        </template>
                        <template v-else-if="topic.likes_count === 1 && topic.user().id == user.id">
                            {{ translations['forum.welcomed_one'] }} {{ translations['forum.introduce_see'] }}
                        </template>
                        <template v-else-if="topic.likes_count != 1 && topic.user().id == user.id">
                            {{ translations['forum.welcomed_more'] }} {{ translations['forum.introduce_see'] }}
                        </template>
                    </template>
                </div>
                <template v-if="user && canSeeLikes">
                    <span v-if="topic.likes_count > 0" class="like-names">
                        <template v-for="like in topic.likes()">
                            <span class="like-name">
                                {{ like.name }}
                            </span>
                            <br>
                        </template>
                    </span>
                    <span v-else class="like-names">
                        <span class="like-name empty-likes">
                            {{ translations['admin.no_likes_first'] }}!
                        </span>
                        <br />
                    </span>
                </template>
            </div>

            <div class="post-comments-count light-text" v-if="showCommentsCount && topic.status != 'invisible'">
                <i class="far fa-comments tw-mr-1">
                    <template v-if="topic.comments_count">
                        <a :href="'/conversations/' + topic.slug" v-if="displayMode === 'small' && !isHelpdesk">
                            <p class="comments-count">{{ topic.comments_count }}</p>
                        </a>
                        <p class="comments-count" v-else>{{ topic.comments_count }}</p>
                    </template>
                    <template v-else>
                        <p class="comments-count">0</p>
                    </template>
                </i>
                <div class="stats-text">
                    <a :href="'/conversations/' + topic.slug"
                        v-if="displayMode === 'small' && translations['profile.comments'] && !isHelpdesk">
                        {{ topic.comments_count === 1 ? translations['profile.comment'].toLowerCase() : translations['profile.comments'].toLowerCase() }}
                    </a>
                    <template v-else>
                        <template v-if="translations['profile.comments']">
                            {{ topic.comments_count === 1 ? translations['profile.comment'].toLowerCase() : translations['profile.comments'].toLowerCase() }}
                        </template>
                        <template v-else>
                            <!-- empty element needed for hide-at -->
                            <p></p>
                        </template>
                    </template>
                </div>
            </div>
            <div v-if="user && showViewsCount" class="post-views-count light-text">
                <i class="far fa-eye"></i>
                <p class="comments-count">{{ topic.views }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Global from '../../mixins/Global.js';
import Feed from '../../mixins/Feed.js';

export default {
    mixins: [Global, Feed],

    props: {
        topic: {
            required: true
        },
        showCommentsCount: {
            default: true
        },
        showLikesCount: {
            default: true
        },
        showViewsCount: {
            default: true
        },
        likeIcon: {
            default: false
        },
        displayMode: {
            required: true,
        }
    },

    data() {
        return {
            isHelpdesk: isHelpdesk,
        }
    },

    computed: {
        canSeeLikes() {
            if (this.topic.status === 'invisible') {
                if (this.topic.user().id === user.id) {
                    return false;
                }
            }

            return true;
        }
    },
}
</script>